<template>
  <div class="g-box">
    <link rel="stylesheet" href="/css/L-01.css">
    <link rel="stylesheet" href="/css/select2.css">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow"><img src="/img/h-search-title.svg" width="178" :alt="$t('Search.title')"></h1>
      <!--現在の検索条件-->
      <ul v-if="last_criteria" class="condition g-clearfix" :aria-label="$t('Search.criteria')">
        <li v-for="(value, name, index) in last_criteria" :key="index" :class="[ last_action === 'rensouObject' ? 'condition_rensou' : 'condition_search' ]">
          <b>{{ $t('Form.'+name) }}</b><span>{{ value | join }}</span>
        </li>
      </ul>
      <!--/現在の検索条件-->
      <!--検索パネル-->
      <div class="searchPanel">
        <transition name="searchPanelSlide">
        <div v-show="shownSearchPanel" class="searchPanel_inner" id="searchPanel_inner" role="region" :aria-expanded="shownSearchPanel">
          <p class="searchPanel_h"><span tabindex="-1">{{ $t('Search.search_panel') }}</span></p>
          <button class="searchPanel_close" type="button" :aria-expanded="shownSearchPanel" aria-controls="searchPanel_inner" @click="toggleSearchPanel">{{ $t('Search.search_panel_close') }}<i class="g-i g-i-close" aria-hidden="true"></i></button>
          <div class="searchPanel_row">
            <form class="searchPanel_col" @submit.prevent="submitSearchForm">
              <dl>
                <dt><i class="g-i g-i-search" aria-hidden="true"></i>{{ $t('Search.advanced_search') }}</dt>
                <dd>
                  <input class="g-input" type="text" v-model="searchRequest.fulltext">
                  <div class="searchPanel_searchArea">
                    <div v-for="search in select_search" :key="search.index" class="searchPanel_search">
                      <Select2 v-model="search.field" :options="select_field" :settings="{ minimumResultsForSearch: Infinity, width: '120px', placeholder: $t('Form.select') }">
                      </Select2>
                      <div class="searchPanel_ctrl">
                        <input class="g-input" type="text" v-model="search.value">
                        <button class="searchPanel_add" type="button" @click="addSelectSearch"><span class="g-clip">{{ $t("Form.add") }}</span><i class="g-i g-i-plus" aria-hidden="true"></i></button>
                        <button class="searchPanel_del" type="button" @click="delSelectSearch(search.index)" :disabled="notDelete"><span class="g-clip">{{ $t("Form.delete") }}</span><i class="g-i g-i-minus" aria-hidden="true"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="searchPanel_multiple">
                    <Select2 v-model="searchRequest.dbs" :options="dbList" :settings="{ multiple: true, minimumResultsForSearch: Infinity, width: '100%', placeholder: $t('Form.dbs') }">
                    </Select2>
                  </div>
                  <div class="searchPanel_buttons">
                    <button class="g-btn g-btn-search" type="submit">{{ $t("Form.submit_search") }}</button>
                    <button class="g-btn g-btn-reset" type="button" @click="resetSearchForm">{{ $t("Form.reset_search") }}</button>
                    <Select2 v-model="limit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '120px' }">
                    </Select2>
                  </div>
                </dd>
              </dl>
            </form>
            <div class="searchPanel_col">
              <dl>
                <dt><i class="g-i g-i-search" aria-hidden="true"></i>{{ $t("Search.rensou_search") }}</dt>
                <dd>
                  <form @submit.prevent="submitRensouForm">
                    <input class="g-input" type="text" v-model="rensouRequest.freetext" :placeholder="$t('Form.rensou_placeholder')">
                    <div class="searchPanel_buttons">
                      <button class="g-btn g-btn-rensou" type="submit">{{ $t("Form.submit_search") }}</button>
                      <button class="g-btn g-btn-reset" type="button" @click="resetRensouForm">{{ $t("Form.reset_rensou") }}</button>
                      <Select2 v-model="limit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '120px' }">
                      </Select2>
                    </div>
                  </form>
                </dd>
              </dl>
              <dl>
                <dt><i class="g-i g-i-db" aria-hidden="true"></i>{{ $t("Form.select_index") }}</dt>
                <dd>
                  <div class="searchPanel_index">
                    <Select2 v-model="select_area" :options="areaFacetList" :settings="{ minimumResultsForSearch: Infinity, width: '100%', placeholder: $t('Form.filter_by_area') }">
                    </Select2>
                    <Select2 v-model="select_nation" :options="nationFacetList" :settings="{ minimumResultsForSearch: Infinity, width: '100%', placeholder: $t('Form.filter_by_nation') }">
                    </Select2>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        </transition>
        <div class="searchPanel_btn">
          <button type="button" :aria-expanded="shownSearchPanel" aria-controls="searchPanel_inner" @click="toggleSearchPanel"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Search.settings") }}</button>
        </div>
      </div>
      <!--/検索パネル-->
        <!--並び替え-->
        <ul v-if="last_action == 'searchObject'" class="g-sort" aria-label="$t('Search.sort')">
          <li><a :class="sortClass('id')" @click="sortBy('id')" :aria-selected="[sort.key == 'id' ? 'true' : '']"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Form.id") }}</a></li>
          <li><a :class="sortClass('name')" @click="sortBy('name')" :aria-selected="[sort.key == 'name' ? 'true' : '']"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Form.name") }}</a></li>
          <li><a :class="sortClass('area')" @click="sortBy('area')" :aria-selected="[sort.key == 'area' ? 'true' : '']"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Form.area") }}</a></li>
          <li><a :class="sortClass('nation')" @click="sortBy('nation')" :aria-selected="[sort.key == 'nation' ? 'true' : '']"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Form.nation") }}</a></li>
          <li><a :class="sortClass('image')" @click="sortBy('image')" :aria-selected="[sort.key == 'image' ? 'true' : '']"><i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Form.image") }}</a></li>
        </ul>
        <!--/並び替え-->
        <!--controls-->
        <div class="g-itemHead">
          <dl class="g-searchWith">
            <dt v-if="this.$i18n.locale != 'en'">{{ $t("Search.rensou_check") }}</dt>
            <dd>
              <button class="g-btn g-btn-lg g-btn-rensou" type="submit" @click="submitRensouForm">{{ $t("Form.submit_rensou") }}</button>
              <button class="g-btn g-btn-sm g-btn-reset" type="reset" @click="clearIds">{{ $t("Form.clear_rensou") }}</button>
            </dd>
          </dl>
          <div class="g-itemHead_block">
            <p class="g-nowrap">{{ $t("Search.total_count", { count: total_count }) }}</p>
            <div style="position: relative">
              <Select2 @change="jumpPage()" v-model="page" :options="pageList" :settings="{ minimumResultsForSearch: Infinity, width: '100px' }" :aria-label="$t('Search.change_page')">
              </Select2>
            </div>
            <ul class="g-pagination">
              <!--↓↓前のページが無い時など、リンクを無効にするときはhref属性を削除してください-->
              <li>
                <a v-if="prev_page" href="#" @click.prevent.stop="jumpPage(prev_page)">
                  <span class="g-clip">{{ $t("Search.prev_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
                <a v-else>
                  <span class="g-clip">{{ $t("Search.prev_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a v-if="next_page" href="#" @click.prevent.stop="jumpPage(next_page)">
                  <span class="g-clip">{{ $t("Search.next_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
                <a v-else>
                  <span class="g-clip">{{ $t("Search.next_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="g-itemHead_block">
            <Select2 v-model="limit" @change="changeLimit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '100px' }" :aria-label="$t('Form.change_limit')">
            </Select2>
            <dl class="g-view" data-target="#itemList">
              <dt v-if="this.$i18n.locale != 'en'">{{ $t("Search.display_type") }}</dt>
              <dd>
                <label class="g-view_list"><span class="g-clip">{{ $t("Search.display_list") }}</span>
                  <input class="g-clip" type="radio" name="view" value="list" v-model="display"><i class="g-i g-i-list" aria-hidden="true"></i>
                </label>
                <label class="g-view_grid"><span class="g-clip">{{ $t("Search.display_grid") }}</span>
                  <input class="g-clip" type="radio" name="view" value="grid" v-model="display" checked><i class="g-i g-i-grid" aria-hidden="true"></i>
                </label>
              </dd>
            </dl>
          </div>
        </div>
        <!--/controls-->
        <!--list-->
        <!--↓↓IDを付けます（何でもOKですが、このIDが表示切替スイッチの指定とマッチすること）-->
        <ul v-if="responseRecords.data.length" :class="display == 'list' ? 'g-itemList' : 'g-itemList g-itemList-grid'" id="itemList">
          <li class="g-itemList_el" v-for="record in responseRecords.data" :key="record.id" :aria-checked="rensouChecked(record.id)">
            <!--↓↓画像はimgタグではなく、background-imageとして記述します-->
            <p class="g-itemList_img" aria-hidden="true">
              <router-link v-if="record.thumbnail" :to="'/detail/'+record.id | lang" :style="'background-image:url('+record.thumbnail+')'"><span class="g-clip">{{ record.fields.__title__ }}</span></router-link>
            </p>
            <div class="g-itemList_info">
              <p class="g-itemList_h"><router-link :to="'/detail/'+record.id | lang">{{ record.fields.__title__ | join }}</router-link></p>
              <p class="g-itemList_id">{{ record.fields.__id__ | join }}</p>
              <p class="g-itemList_id_text">{{ $t("List.__id__", { value: record.fields.__id__ }) }}</p>
              <div class="g-itemList_etc">
                <p v-if="record.fields.area">{{ $t("List.area", { value: record.fields.area }) }}</p>
                <p v-if="record.fields.nation">{{ $t("List.nation", { value: record.fields.nation }) }}</p>
                <p v-if="record.fields.age">{{ $t("List.age", { value: record.fields.age }) }}</p>
              </div>
              <label class="g-itemList_check">
                <input class="g-clip" type="checkbox" :checked="rensouChecked(record.id)" @click.stop="checkRensou(record.id)"><i class="g-i g-i-check" aria-hidden="true"></i><span>{{ $t("Form.rensou_pickup") }}</span>
              </label>
            </div>
          </li>
          <!--↓↓グリッド表示時、列数で割り切れない時に平仄を合わせるため、ダミーカラムを書いておきます（適当に10個でよいです）-->
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
        </ul>
        <div v-else-if="responseRecords.status == 200" class="g-itemList_notfound">{{ $t("Search.not_found") }}</div>
        <div v-else class="g-itemList_notfound">{{ $t("Search.loading") }}</div>
        <!--/list-->
        <!--controls-->
        <div class="g-itemHead">
          <dl class="g-searchWith">
            <dt v-if="this.$i18n.locale != 'en'">{{ $t("Search.rensou_check") }}</dt>
            <dd>
              <button class="g-btn g-btn-lg g-btn-rensou" type="submit" @click="submitRensouForm">{{ $t("Form.submit_rensou") }}</button>
              <button class="g-btn g-btn-sm g-btn-reset" type="reset" @click="clearIds">{{ $t("Form.clear_rensou") }}</button>
            </dd>
          </dl>
          <div class="g-itemHead_block">
            <p class="g-nowrap">{{ $t("Search.total_count", { count: total_count }) }}</p>
            <div style="position: relative">
              <Select2 @change="jumpPage()" v-model="page" :options="pageList" :settings="{ minimumResultsForSearch: Infinity, width: '100px' }" :aria-label="$t('Search.change_page')">
              </Select2>
            </div>
            <ul class="g-pagination">
              <!--↓↓前のページが無い時など、リンクを無効にするときはhref属性を削除してください-->
              <li>
                <a v-if="prev_page" href="#" @click.prevent.stop="jumpPage(prev_page)">
                  <span class="g-clip">{{ $t("Search.prev_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
                <a v-else>
                  <span class="g-clip">{{ $t("Search.prev_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a v-if="next_page" href="#" @click.prevent.stop="jumpPage(next_page)">
                  <span class="g-clip">{{ $t("Search.next_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
                <a v-else>
                  <span class="g-clip">{{ $t("Search.next_page") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="g-itemHead_block">
            <Select2 v-model="limit" @change="changeLimit" :options="limit_options" :settings="{ minimumResultsForSearch: Infinity, width: '100px' }" :aria-label="$t('Form.change_limit')">
            </Select2>
            <dl class="g-view" data-target="#itemList">
              <dt v-if="this.$i18n.locale != 'en'">{{ $t("Search.display_type") }}</dt>
              <dd>
                <label class="g-view_list"><span class="g-clip">{{ $t("Search.display_list") }}</span>
                  <input class="g-clip" type="radio" name="view2" value="list" v-model="display"><i class="g-i g-i-list" aria-hidden="true"></i>
                </label>
                <label class="g-view_grid"><span class="g-clip">{{ $t("Search.display_grid") }}</span>
                  <input class="g-clip" type="radio" name="view2" value="grid" v-model="display" checked><i class="g-i g-i-grid" aria-hidden="true"></i>
                </label>
              </dd>
            </dl>
          </div>
        </div>
        <!--/controls-->
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import mainMixin from '@/mixins/mainMixin.js'
import i18n from '@/i18n.js'
import Select2 from 'v-select2-component'
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  name: 'Search',
  mixins: [ mainMixin ],
  components: {
    Select2,
    breadcrumb
  },
  props: {
    dbList: { type: Array, required: true },
    listLimit: { type: Array, required: true },
  },
  data () {
    return {
      searchRequest: {
        fulltext: '',
        dbs: [],
        id: '',
        name: '',
        age: '',
        area: '',
        nation: '',
        owc: '',
        ocm: '',
        fyear: '',
        exact_fields: ''
      },
      rensouRequest: {
        freetext: '',
        ids: [],
      },
      limit: 25,
      page: 1,
      sort: {
        key: 'id',
        direction: 'asc'
      },
      select_search: [],
      select_area: '',
      select_nation: '',
      shownSearchPanel: false
    }
  },
  filters: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/search', text: 'Search.title' },
      ]
    },
    // 検索項目指定フォームが1つしかないときは削除できないようにする
    notDelete: function() {
      return (this.select_search.length === 1 ? true : false)
    },
    // 前回の検索条件の表示用
    last_criteria: function() {
      let params = {}
      const req = this.$route.query
      Object.keys(req).forEach(function (key) {
        const exclude_params = ['sort', 'order', 'lang', 'page', 'limit', 'grouping', 'exact_fields']
        if (exclude_params.indexOf(key) < 0) {
          if (key === 'dbs') {
            if (req[key].length) {
              this.$set(params, key, this.getTargetDB(req[key]))
            }
          } else if (key === 'ids') {
            if (req[key].length) {
              this.$set(params, key, req[key])
            }
          } else {
            if (req[key]) {
              this.$set(params, key, req[key])
            }
          }
        }
      }.bind(this));
      return params
    },
    // APIからのレスポンスデータから検索結果データを取得
    responseRecords: function() {
      if (this.$store.getters.response_status) {
        return {status: 200, data: this.$store.getters.response_records}
      }
      return {status: 404, data: []}
    },
    // APIからのレスポンスデータから地域ファセットデータを取得
    areaFacetList: function() {
      if (this.$store.getters.response_status) {
        const areas = this.$store.getters.response_facets.area
        if (areas) {
          // 詳細検索にセットされていたらこちらへ移行
          this.select_search.forEach(search => {
            if (search.field && search.value) {
              Object.keys(areas).forEach(key => {
                if (search.field == 'area' && search.value == key) {
                  this.select_area = search.value
                  return true
                }
              });
            }
          });

          const fields = []
          if (this.select_area) {
            fields.push({id:'[all]', text:'絞り込みを解除する'})
          }
          Object.keys(areas).forEach(function (key) {
            fields.push({id:key, text:key+'('+areas[key]+')'})
          }.bind(this));
          return fields
        }
      }
      return []
    },
    // APIからのレスポンスデータから民族ファセットデータを取得
    nationFacetList: function() {
      if (this.$store.getters.response_status) {
        const nations = this.$store.getters.response_facets.nation
        if (nations) {
          // 詳細検索にセットされていたらこちらへ移行
          this.select_search.forEach(search => {
            if (search.field && search.value) {
              Object.keys(nations).forEach(key => {
                if (search.field == 'nation' && search.value == key) {
                  this.select_nation = search.value
                  return true
                }
              });
            }
          });

          const fields = []
          if (this.select_nation) {
            fields.push({id:'[all]', text:'絞り込みを解除する'})
          }
          Object.keys(nations).forEach(function (key) {
            fields.push({id:key, text:key+'('+nations[key]+')'})
          }.bind(this));
          return fields
        }
      }
      return []
    },
    // 前回の検索タイプ（一致検索か？連想検索か？）
    last_action: function() {
      return this.$store.getters.last_action
    },
    // 検索項目指定フォームの項目選択セレクトボックス用
    select_field: function() {
      const fields = []
      Object.keys(this.searchRequest).forEach(function (key) {
        const exclude_fields = ['fulltext', 'dbs']
        if (exclude_fields.indexOf(key) < 0) {
          fields.push({id:key, text:i18n.t('Form.'+key)})
        }
      }.bind(this));
      return fields
    },
    // 検索結果の表示ページ選択セレクトボックス用
    pageList: function() {
      let start = 1
      let end = this.$store.getters.response_pages
      if(end == 0) {
        end = 1
      }
      const list = []
      for (let i = start; i <= end; i++) {
        const endCount = Math.min(i * this.limit, this.$store.getters.response_total)
        list.push({id:i, text: `${(i-1) * this.limit + 1}-${endCount}`});
      }
      return list
    },
    // 検索結果全件の件数取得
    total_count: function() {
      return this.$store.getters.response_total
    },
    // 現在の検索結果ページの前ページ番号の取得
    prev_page: function() {
      return this.page - 1
    },
    // 現在の検索結果ページの次ページ番号の取得
    next_page: function() {
      return this.page == this.$store.getters.response_pages ? 0 : parseInt(this.page) + 1
    },
    // 検索結果一覧の表示数選択セレクトボックス用
    limit_options: function() {
      const options = []
      this.listLimit.forEach(function (limit) {
        options.push({id:limit, text:i18n.t("Form.display_count", { count: limit })})
      });
      return options
    },
    // 一覧表示をリスト形式にするか、グリッド形式にするか
    display: {
      get() {
        return this.$store.state.display ? this.$store.state.display : 'grid'
      },
      set(val) {
        this.$store.commit('setDisplay', val)
      }
    }
  },
  watch: {
    // 絞り込みが指定されたら検索結果を再描画
    select_area: 'selectArea',
    select_nation: 'selectNation',
    // ページが変わったらURLにセット
    page: function() {
      this.$route.query.limit = this.limit
      this.$router.push({ query: { ...this.$route.query, page: this.page } }, () => {}, () => {})
    },
  },
  // このページ内でパラメータが変わった時の処理
  beforeRouteUpdate (to, from, next) {
    if (to.query) {
      if (to.query.limit) {
        this.limit = to.query.limit
      }
      if (to.query.page) {
        this.page = to.query.page
      } else {
        this.page = 1
      }
      if (to.query.sort) {
        this.sort.key = to.query.sort
      }
      if (to.query.order) {
        this.sort.direction = to.query.order
      }
      this.getResults(to.query)
    }
    next()
  },
  // ページ表示前の処理
  mounted: function() {
    this.hasResult = false

    // 前回の検索結果があったら消しておく
    this.$store.commit('clearResponceStatus')

    /*
    if (this.$route.query.q) {
      if(this.$route.query.limit) {
        this.limit = this.$route.query.limit
      }
      if (this.$route.query.page) {
        this.page = this.$route.query.page
      }
      this.getResults(this.$route.query.q)
    }
    */
    if (this.$route.query.limit) {
      this.limit = this.$route.query.limit
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    if (this.$route.query.sort) {
      this.sort.key = this.$route.query.sort
    }
    if (this.$route.query.order) {
      this.sort.direction = this.$route.query.order
    }
    
    this.getResults(this.$route.query)
  },
  methods: {
    // 一致検索の実行
    submitSearchForm() {
      const request = this.searchRequest
      this.select_field.forEach(function (field) {
        request[field.id] = ''
      });
      this.select_search.forEach(function (search) {
        if (search.field && search.value) {
          if (request[search.field]) {
            request[search.field] = request[search.field] + ' ' + search.value
          } else {
            request[search.field] = search.value
          }
        }
      });
      this.page = 1
      this.setQueries('searchObject')
      this.resetRensouForm()
    },
    // 前回の一致検索条件を取得
    resetSearchForm(request) {
      this.searchRequest = {
        fulltext: '',
        dbs: [],
        id: '',
        name: '',
        age: '',
        area: '',
        nation: '',
        owc: '',
        ocm: '',
        fyear: '',
        exact_fields: ''
      }
      request = request || this.$route.query
      if (request) {
        this.$set(this.searchRequest, 'fulltext', request.fulltext ? request.fulltext : '')
        this.$set(this.searchRequest, 'dbs', request.dbs ? request.dbs : [])
        this.$set(this.searchRequest, 'id', request.id ? request.id : '')
        this.$set(this.searchRequest, 'name', request.name ? request.name : '')
        this.$set(this.searchRequest, 'age', request.age ? request.age : '')
        this.$set(this.searchRequest, 'area', request.area ? request.area : '')
        this.$set(this.searchRequest, 'nation', request.nation ? request.nation : '')
        this.$set(this.searchRequest, 'owc', request.owc ? request.owc : '')
        this.$set(this.searchRequest, 'ocm', request.ocm ? request.ocm : '')
        this.$set(this.searchRequest, 'fyear', request.fyear ? request.fyear : '')
        this.$set(this.searchRequest, 'exact_fields', request.exact_fields ? request.exact_fields : '')
      }
      this.select_search = []
      this.select_field.forEach(function (field) {
        if (field.id === 'exact_fields') {
          return
        }
        if (this.searchRequest[field.id]) {
          let values = []
          /*
          const regexp = new RegExp(field.id)
          if (this.searchRequest.exact_fields) {
            if (this.searchRequest.exact_fields.match(regexp)) {
              return
            } else {
              if (this.searchRequest[field.id].match(/^"(.*)"$/)) {
                values.push(this.searchRequest[field.id])
              } else {
                values = this.searchRequest[field.id].split(/\s/)
              }
            }
          } else { */
            if (this.searchRequest[field.id].match(/^"(.*)"$/)) {
              values.push(this.searchRequest[field.id])
            } else {
              //values = this.searchRequest[field.id].split(/\s/)
              values.push(this.searchRequest[field.id])
            }
          /* } */
          values.forEach(function (value) {
            const index = this.select_search.length + 1
            this.select_search.push({index: index, field: field.id, value: value})
          }, this);
        }
      }, this);
      if (!this.select_search.length) {
        this.select_search.push({index: 1, field: '', value: ''})
      }
    },
    // 連想検索の実行
    submitRensouForm() {
      this.page = 1
      this.setQueries('rensouObject')
      this.resetSearchForm()
    },
    // 前回の連想検索条件を取得
    resetRensouForm(request) {
      this.rensouRequest = {
        freetext: '',
        ids: [],
      }
      request = request || this.$route.query
      if (request) {
        if (request.ids) {
          if (request.ids instanceof Array == false) {
            request.ids = [request.ids]
          }
        }
        this.$set(this.rensouRequest, 'freetext', request.freetext ? request.freetext : '')
        this.$set(this.rensouRequest, 'ids', request.ids ? Vue.util.extend([], request.ids) : [])
      }
    },
    // 検索クエリの送信
    setQueries(action) {
      let request = this.rensouRequest
      if (action !== 'rensouObject') {
        request = this.searchRequest
        request.sort = this.sort.key
        request.order = this.sort.direction
        action = 'searchObject'
      }
      request.limit = this.limit

      // 空のプロパティを削除
      for(let i in request) {
        if(request[i] === "" || request[i] === []){
          delete request[i];
        }
      }
      this.$router.push({ path: this.$route.path, query: request}).catch(err => {
        if (err.name != "NavigationDuplicated") {
          throw err;
        }
      });
    },
    // 検索結果の表示
    getResults(req) {
      let action = ''
      let request = req || {}
      if (request) {
        if (request.freetext || request.ids) {
          action = 'rensouObject'
          this.rensouRequest = Vue.util.extend({}, request)
        } else {
          action = 'searchObject'
          this.searchRequest = Vue.util.extend({}, request)
        }
      }
      
      request.sort = request.sort || this.sort.key
      request.order = request.order || this.sort.direction
      request.lang = i18n.locale
      request.limit = this.limit
      request.page = this.page
      request.grouping = 'area,nation'
      // 検索結果の表示
      this.$store.dispatch(action, request)
      // 詳細ページで使うため、現在の検索条件を記録
      this.$store.commit('setCurrentQ', request)
      // 検索フォームのクリア
      this.resetSearchForm(request)
      this.resetRensouForm(request)
    },
    // 現在のソート条件の表示用
    sortClass(key) {
      if (this.sort.key === key) {
        if (this.sort.direction === 'asc') {
          return 'g-sort_asc'
        }
        if (this.sort.direction === 'desc') {
          return 'g-sort_desc'
        }
      }
      return ""
    },
    // ソート条件の切り替え
    sortBy(key) {
      if (this.sort.key !== key) {
        this.sort.key = key
        this.sort.direction = 'asc'
      } else {
        if (this.sort.direction === 'asc') {
          this.sort.direction = 'desc'
        } else {
          this.sort.direction = 'asc'
        }
      }
      this.changeOrder()
    },
    // ソート条件が切り替わったら検索結果一覧の再描画
    changeOrder() {
      const sort = this.sort.key
      const order = this.sort.direction
      this.resetSearchForm()
      this.page = 1
      this.sort.key = sort
      this.sort.direction = order
      this.setQueries()
    },
    // 一覧表示件数が変わったら検索結果一覧の再描画
    changeLimit() {
      this.resetSearchForm()
      this.page = 1
      this.setQueries(this.last_action)
    },
    // ページ数を指定して検索結果一覧を再描画する用
    jumpPage(jumpTo = null) {
      if (jumpTo) {
        this.page = jumpTo
      }
    },
    // 前回の検索条件で検索対象にしたDB名の表示用
    getTargetDB(keys) {
      if (!keys) {
        return ''
      }
      if (this.dbList.length > 0) {
        if (Array.isArray(keys)) {
          const db_array = []
          keys.forEach(function (key) {
            const db = this.dbList.find(db => db.id == key)
            if (db) {
              db_array.push(db.text)
            }
          }, this);
          return db_array.join(', ')
        } else {
          return this.dbList.find(db => db.id == keys).text
        }
      }
    },
    // 検索結果を地域で絞り込む用（一致検索用）
    selectArea() {
      if(this.select_area == this.searchRequest.area) {
        // 条件が変わらない時は無駄なクエリ変更を発火させない
        return
      }

      this.resetSearchForm()
      if (this.select_area == '[all]') {
        this.select_area = ''
        this.searchRequest.area = this.select_area
        const exact_fields_before = this.searchRequest.exact_fields.split(',')
        const exact_fields_after = exact_fields_before.filter(field => field !== 'area')
        this.searchRequest.exact_fields = exact_fields_after.join()
      } else {
        this.searchRequest.area = this.select_area
        if (this.searchRequest.exact_fields) {
          if (this.searchRequest.exact_fields.indexOf('area') == -1) {
            this.searchRequest.exact_fields += ',area'
          }
        } else {
          this.searchRequest.exact_fields = 'area'
        }
      }
      this.page = 1
      this.setQueries('searchObject')
    },
    // 検索結果を民族で絞り込む用（一致検索用）
    selectNation() {
      if(this.select_nation == this.searchRequest.nation) {
        // 条件が変わらない時は無駄なクエリ変更を発火させない
        return
      }
      this.resetSearchForm()
      if (this.select_nation == '[all]') {
        this.select_nation = ''
        this.searchRequest.nation = this.select_nation
        const exact_fields_before = this.searchRequest.exact_fields.split(',')
        const exact_fields_after = exact_fields_before.filter(field => field !== 'nation')
        this.searchRequest.exact_fields = exact_fields_after.join()
      } else {
        this.searchRequest.nation = this.select_nation
        if (this.searchRequest.exact_fields) {
          if (this.searchRequest.exact_fields.indexOf('nation') == -1) {
            this.searchRequest.exact_fields += ',nation'
          }
        } else {
          this.searchRequest.exact_fields = 'nation'
        }
      }
      this.page = 1
      this.setQueries('searchObject')
    },
    // 連想検索条件にする資料のチェック用
    checkRensou(id) {
      if (this.rensouRequest.ids.includes(id)) {
        this.rensouRequest.ids = this.rensouRequest.ids.filter((item) => item != id)
      } else {
        this.rensouRequest.ids.push(id)
      }
    },
    // 連想検索条件になっている資料かどうかの確認用
    rensouChecked(id) {
      if (this.rensouRequest.ids.includes(id)) {
        return true
      }
      return false
    },
    // 連想検索条件になっている資料のクリア
    clearIds() {
      this.rensouRequest.ids = []
    },
    // 検索項目指定フォームの追加
    addSelectSearch() {
      const index = this.select_search.length + 1
      this.select_search.push({index: index, field: '', value: ''})
    },
    // 検索項目指定フォームの削除
    delSelectSearch(index) {
      this.select_search = this.select_search.filter((item) => item.index != index)
    },
    // 検索条件設定欄の開閉用
    toggleSearchPanel() {
      this.shownSearchPanel = !this.shownSearchPanel
    }
  },
  head: {
    title: function () {
      return {
        inner: i18n.t('Site.title') + ' ' + i18n.t('Site.search'),
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: i18n.t('Site.title') + ' ' + i18n.t('Site.search') },
      ]
    }
  }
}
</script>
